var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSnFTools(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11923_27431)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.993 11.5862C23.7749 5.15039 18.4889 0 12 0C5.37258 0 0 5.37258 0 12C0 18.4889 5.15039 23.7749 11.5862 23.993V24H24V11.5862H23.993ZM22.3448 22.3448H11.5862V22.3367C6.06475 22.1195 1.65517 17.5747 1.65517 12C1.65517 6.28671 6.28671 1.65517 12 1.65517C17.5747 1.65517 22.1195 6.06475 22.3367 11.5862H22.3448V22.3448ZM16.578 11.6184L5.47972 11.6184L5.4797 8.65889H16.5779L16.578 11.6184ZM20.2773 10.1387L17.3178 11.6184L17.3178 8.65889L20.2773 10.1387ZM18.0345 13H19V14.7416H18.0345V13ZM5.96552 13.0003H5V14.7416H5.96552V13.0003ZM19 15.9888H5V17.1554H19V15.9888ZM12.2414 14.7416V13H11.7586V14.7416H12.2414ZM6.93103 14.0003H7.41379V14.7416H6.93103V14.0003ZM8.86207 14.0003H8.37931V14.7416H8.86207V14.0003ZM9.82759 14.0003H10.3103V14.7416H9.82759V14.0003ZM14.1724 14.0003H13.6897V14.7416H14.1724V14.0003ZM15.1379 14.0003H15.6207V14.7416H15.1379V14.0003ZM17.069 14.0003H16.5862V14.7416H17.069V14.0003Z",
    fill: "#313131"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11923_27431"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnFTools);
export default __webpack_public_path__ + "static/media/SnFTools.c0382479e5119750f0fa15efb419db8d.svg";
export { ForwardRef as ReactComponent };